import Env from "../config/env";

const ValidateSizeFile = (file, tamanio = Env.AllowedSize) => {
    const sizeKbs = (file.size / 1024); // Convierte de Bytes a Kilobytes
    const sizeMbs = (sizeKbs / 1024); // Convierte de Kilobytes a Megabytes
    if (sizeMbs > tamanio) {
        return false;
    }
    return true;
}
export default ValidateSizeFile;